import URL from 'url-parse';

export const getSearchParams = () => {
  try {
    const pageUrl = location.href;
    const parsedUrl = new URL(pageUrl, true);

    return parsedUrl.query || {};
  } catch (error) {
    return {};
  }
};
